<template>
    <div class="box">
        <div class="news">
            <div class="newsleft">
                <div class="leftpic">
                    <img src="../../static/NEWS _CENTER.png" style="height: 80px;" />
                </div>
                <div class="leftpic1">
                    <img src="../../static/line.png" style="width: 100%; height: 100%" />
                </div>
                <div class="leftTitle">最新动态</div>
                <div class="tabs">
                    <div @click="tabChange(item)" v-for="item in classList" :key="item.dictSort">
                        <p :class="{ active: tabIndex == item.dictSort }">{{ item.dictLabel }}</p>
                        <div class="line" v-if="tabIndex == item.dictSort"></div>
                    </div>

                    <!--                    <div @click="tabChange(1)">-->
                    <!--                        <p :class="{ active: tabIndex == 1 }">行业动态</p>-->
                    <!--                        <div class="line" v-if="tabIndex == 1"></div>-->
                    <!--                    </div>-->

                    <!--                    <div @click="tabChange(2)">-->
                    <!--                        <p :class="{ active: tabIndex == 2 }">-->
                    <!--                            投资企业动态-->
                    <!--                        </p>-->
                    <!--                        <div class="line" v-if="tabIndex == 2"></div>-->
                    <!--                    </div>-->
                </div>
                <div class="jia" @click="jumpList">
                    <img src="../../static/jia.png" style="width: 100%; height: 100%" />
                </div>
            </div>
            <div class="newsright">
                <dataNone style="transform: translateY(50%);" v-if="list.length == 0"></dataNone>
                <template v-if="list.length != 0">
                    <div class="righttop">
                        <div class="topleft" style="cursor: pointer;" @click="jumpDet(fistCount)">
                            <img :src="fistCount.coverOssUrl" style="width: 100%; height: 100%" />
                            <div class="leftTitle">
                                <p class="titleLeft">
                                    {{ fistCount.title }}
                                </p>
                                <p class="titleright">{{ fistCount.createTime }}</p>
                            </div>
                        </div>
                        <div class="topright">
                            <div class="rightli" v-for="item in secondList" :key="item.id" @click="jumpDet(item)">
                                <div class="lileft">
                                    <img :src="item.coverOssUrl" alt="" style="width: 100%; height: 100%" />
                                </div>
                                <div class="liright">
                                    <div class="righttitle">
                                        {{ item.title }}
                                    </div>
                                    <div class="litime">{{ item.createTime }}</div>
                                    <div class="licount" v-html="item.remark">{{ item.remark }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="rightbot">
                        <!-- <div class="topright"> -->
                        <div class="rightli" v-for="item in treeList" :key="item.id" @click="jumpDet(item)">
                            <div class="lileft">
                                <img :src="item.coverOssUrl" alt="" style="width: 100%; height: 100%" />
                            </div>
                            <div class="liright">
                                <div class="righttitle">
                                    {{ item.title }}
                                </div>
                                <div class="litime">{{ item.createTime }}</div>
                                <div class="licount" v-html="item.remark">{{ item.remark }}</div>
                            </div>
                        </div>
                        <!-- </div> -->
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import dataNone from '@/components/dataNone.vue';
export default {
    name: 'nextNews',
    components: {
        dataNone
    },
    data() {
        return {
            tabIndex: 0,
            classList: [],
            list: [],
            secondList: [],
            treeList: [],
            fistCount: {},
            queryParams: {
                pageSize: 10,
                pageNum: 1,
                classify: ""
            }
        }
    },
    created() {
        this.getClass()
    },
    methods: {
        // 跳转文章列表
        jumpList() {
            this.$router.push({
                path: "/newsCenter", query: {
                    type: 'xwzx',
                    tabInd: 2
                }
            });
        },
        // 跳转文章详情
        jumpDet(v) {
            this.$router.push({
                path: "/articleDet", query: {
                    pageType: 'xwzx',
                    pageName: this.classList[this.tabIndex - 1].dictLabel,
                    ...v
                }
            });
        },
        tabChange(row) {
            this.tabIndex = row.dictSort
            this.getList(row.dictSort)
        },
        getClass() {
            this.$api.getPressClassify().then(res => {
                // console.log(res,'-----新闻动态')
                this.classList = res.data.length != 0 ? res.data : res.data
                this.tabIndex = res.data.length != 0 ? res.data[0].dictSort : 0
                this.getList(res.data.length != 0 ? res.data[0].dictSort : 0)
            })
        },
        getList(dictCode) {
            this.queryParams.classify = dictCode
            this.list = []
            this.secondList = []
            this.treeList = []
            this.$api.getpressCenter(this.queryParams).then(res => {
                console.log(res, '----新闻列表')
                this.list = res.rows.length != 0 ? res.rows : []
                if (this.list.length != 0) {
                    this.list.forEach(item => {
                        item.createTime = item.createTime.split(' ')[0]
                    })
                    this.fistCount = this.list[0]
                    if (this.list.length >= 3) {
                        let arraylist = JSON.parse(JSON.stringify(this.list))
                        this.secondList = arraylist.splice(1, 2)
                    }
                    if (this.list.length > 3) {
                        let arraylist = JSON.parse(JSON.stringify(this.list))
                        this.treeList = arraylist.splice(3, arraylist.length - 1)
                        console.log(this.list, this.treeList, '-----')
                    }
                } else {
                    this.list = []
                    this.secondList = []
                    this.treeList = []
                    this.fistCount = {}
                }
            })
        },
    },
}
</script>

<style scoped lang="less">
.active {
    // font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 600;
    font-size: 20px;
    color: #1e439b;
    // line-height: 0px;
    // text-align: left;
    // font-style: normal;
    // text-transform: none;
}

.news {
    margin: 0 auto;
    height: 100%;
    background-color: #fff;
    display: flex;
    box-sizing: border-box;
    padding: 100px 6.5rem;
    min-width: 93.75rem
        /* 1500/16 */
    ;
    width: 93.75rem;
    // overflow: hidden;

    .newsleft {
        margin-right: 130px;

        .leftpic {
            width: 170px;
            height: 95px;
            // margin-bottom: 30px;
        }

        .leftpic1 {
            width: 89px;
            margin-top: 31px;
            margin-bottom: 60px;
        }

        .leftTitle {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: bold;
            font-size: 35px;
            color: #333333;
            line-height: 0px;
            text-align: left;
            font-style: normal;
            text-transform: none;
        }

        .tabs {
            margin-top: 154px;
            margin-bottom: 139px;
        }

        .line {
            width: 80px;
            height: 2px;
            background: #1e439b;
            border-radius: 0px 0px 0px 0px;
        }

        .tabs div {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 20px;
            color: #333333;
            text-align: left;
            font-style: normal;
            text-transform: none;
            margin-bottom: 38px;
            cursor: pointer;
        }

        .jia {
            width: 50px;
            height: 50px;
            cursor: pointer;
        }
    }

    .newsright {
        .righttop {
            display: flex;

            .topleft {
                width: 490px;
                height: 350px;
                margin-right: 30px;
                position: relative;

                .leftTitle {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0px 30px;

                    .titleLeft {
                        width: 220px;
                        height: 30px;
                        line-height: 15px;
                        font-family: Source Han Sans CN, Source Han Sans CN;
                        font-weight: 400;
                        font-size: 18px;
                        color: #ffffff;
                        text-align: left;
                        font-style: normal;
                        text-transform: none;
                        margin-right: 95px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    .titleright {
                        width: 110px;
                        height: 30px;
                        line-height: 15px;
                        font-family: Source Han Sans CN, Source Han Sans CN;
                        font-weight: 400;
                        font-size: 18px;
                        color: #ffffff;
                        text-align: left;
                        font-style: normal;
                        text-transform: none;
                    }
                }
            }

            .topright {
                .rightli {
                    cursor: pointer;
                    width: 575px;
                    // height: 160px;
                    background: #ffffff;
                    border-radius: 0px 0px 0px 0px;
                    padding: 30px;
                    margin-bottom: 30px;
                    display: flex;

                    .lileft {
                        width: 155px;
                        height: 100px;
                        margin-right: 20px;
                    }

                    .liright {

                        .righttitle {
                            width: 324px;
                            // height: 18px;
                            font-family: Source Han Sans CN,
                                Source Han Sans CN;
                            font-weight: 400;
                            font-size: 18px;
                            color: #333333;
                            text-align: left;
                            font-style: normal;
                            text-transform: none;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }

                        .litime {
                            margin: 15px 0px;
                            // width: 81px;
                            height: 16px;
                            font-family: Source Han Sans CN,
                                Source Han Sans CN;
                            font-weight: 400;
                            font-size: 16px;
                            color: #999999;
                            // line-height: 50px;
                            text-align: left;
                            font-style: normal;
                            text-transform: none;
                        }

                        .licount {
                            width: 300px;
                            // height: 16px;
                            font-family: Source Han Sans CN,
                                Source Han Sans CN;
                            font-weight: 400;
                            font-size: 16px;
                            color: #999999;
                            // line-height: 50px;
                            text-align: left;
                            font-style: normal;
                            text-transform: none;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 1;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }
                    }
                }
            }
        }

        .rightbot {
            display: flex;
            // align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;

            // .topright {
            .rightli {
                width: 575px;
                // height: 160px;
                background: #ffffff;
                border-radius: 0px 0px 0px 0px;
                padding: 30px;
                margin-bottom: 30px;
                display: flex;
                cursor: pointer;


                .lileft {
                    width: 155px;
                    height: 100px;
                    margin-right: 20px;
                }

                .liright {
                    .righttitle {
                        width: 324px;
                        // height: 18px;
                        font-family: Source Han Sans CN,
                            Source Han Sans CN;
                        font-weight: 400;
                        font-size: 18px;
                        color: #333333;
                        text-align: left;
                        font-style: normal;
                        text-transform: none;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    .litime {
                        margin: 15px 0px;
                        // width: 81px;
                        height: 16px;
                        font-family: Source Han Sans CN,
                            Source Han Sans CN;
                        font-weight: 400;
                        font-size: 16px;
                        color: #999999;
                        // line-height: 50px;
                        text-align: left;
                        font-style: normal;
                        text-transform: none;
                    }

                    .licount {
                        width: 300px;
                        // height: 16px;
                        font-family: Source Han Sans CN,
                            Source Han Sans CN;
                        font-weight: 400;
                        font-size: 16px;
                        color: #999999;
                        // line-height: 50px;
                        text-align: left;
                        font-style: normal;
                        text-transform: none;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }

                // }
            }
        }
    }
}

.box {
    background-color: #f7f7f7;

}
</style>
